export default {"src":"/_next/static/media/theme-moon.ca55c1a0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};